export const BALANCE_SUBSCRIPTION_MESSAGE = { name: 'Balance' }
